module.exports = {"130109100":"廉州镇","130109101":"兴安镇","130109102":"贾市庄镇","130109103":"南营镇","130109104":"梅花镇","130109105":"岗上镇","130109107":"南董镇","130109108":"张家庄镇","130109109":"南孟镇","130109110":"增村镇","130109111":"常安镇","130109112":"西关镇","130109200":"九门回族乡","130109500":"石家庄经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130109.json
// module id = 147
// module chunks = 0